import { render, staticRenderFns } from "./UploadStockData.vue?vue&type=template&id=45d95c6a&"
import script from "./UploadStockData.vue?vue&type=script&lang=js&"
export * from "./UploadStockData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports